<template lang="html">
  <Layout currentMenu="Profile">
    <div class="gap-3x mobile-only" />
    <LoadingSection title="Profile" :loading="loading" :autoPadding="false">
      <template v-slot:content>
        <div class="section-field flex-box wrap">
          <h3 class="black pull-left bgap-24">General</h3>
          <div class="right pull-right">
            <SymbiumFormGroup
              label="First Name"
              v-bind:value.sync="firstName"
              @update:value="(value) => onInputUpdate(value, 'firstName')"
              inputSize="profile-input-size"
            />

            <div class="gap-3x" />
            <SymbiumFormGroup
              label="Last Name"
              v-bind:value.sync="lastName"
              @update:value="(value) => onInputUpdate(value, 'lastName')"
              inputSize="profile-input-size"
            />

            <div class="gap-3x" />
            <SymbiumFormGroup
              label="Email"
              v-bind:value.sync="email"
              :locked="true"
              inputSize="profile-input-size"
            />

            <div class="gap-3x" />
            <SymbiumFormGroup
              label="Phone"
              v-bind:value.sync="phone"
              @update:value="(value) => onInputUpdate(value, 'phone')"
              inputSize="profile-input-size"
            />

            <div class="gap-3x" />
            <SymbiumFormGroup
              label="Organization"
              v-bind:value.sync="organization"
              :locked="true"
              inputSize="profile-input-size"
            />

            <div class="gap-3x" />
            <SymbiumButton
              text="Save"
              :loading="submitting"
              buttonSize="profile-button-size"
              :onClick="submitData"
              :isDisabled="notAllowed"
            />
          </div>
        </div>
      </template>
    </LoadingSection>
    <AlertSuccessModal :title="alertMessage" />

    <LoadingSection :loading="loading" :autoPadding="false">
      <template v-slot:content>
        <div>
          <div class="section-field flex-box wrap security-section">
            <h3 class="black pull-left bgap-24">Security</h3>
            <div class="right pull-right flex-box wrap">
              <h4 class="black bgap-32 sub-section">Two-factor Authentication</h4>
              <div class="flex-box vertically-centered move-up bgap-16" v-if="!qrCode">
                <div class="margin-right-3x body-17 gray">
                  {{ user.enabled_2fa ? "On" : "Off" }}
                </div>
                <SymbiumButton
                  :text="user.enabled_2fa ? 'Change' : 'Setup'"
                  :loading="loadingQrCode"
                  buttonSize="profile-button-size"
                  :onClick="loadQrCode"
                  :isPrimary="true"
                  :isSmall="true"
                  v-if="!qrCode"
                />
              </div>
              <div class="flex-box wrap flexible bgap-24" v-if="qrCode">
                <div class="body-16 gray max-size">
                  <span class="black bold">Step 1</span>. Please scan the QR code below with an authenticator app, e.g., Google Authenticator, Duo etc.
                </div>
                <div class="max-size">
                  <img :src="qrCode">
                </div>
                <div class="body-16 gray max-size bgap-16">
                  <span class="black bold">Step 2</span>. Enter the 6-digit code from your authenticator app.
                </div>
                <div class="bgap-16 max-size">
                  <SymbiumFormGroup
                    placeholder="Authentication code"
                    v-bind:value.sync="authentication_code"
                    inputSize="profile-input-size-small"
                    :error="error"
                  />
                </div>

                <div class="flex-box max-size">
                  <div class="hgap-16-right">
                    <SymbiumButton
                      text="Cancel"
                      :onClick="cancel"
                      :isDialog="true"
                      :isSmall="true"
                    />
                  </div>

                  <SymbiumButton
                    text="Enable 2FA"
                    :onClick="submit2Fa"
                    :loading='submitting'
                    :isPrimary="true"
                    :isSmall="true"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="user.enabled_2fa">
            <div class="line-break-gray right pull-right"></div>
            <div class="section-field flex-box wrap security-section account-recovery">
              <div class="right pull-right flex-box wrap">
                <h4 class="black bgap-32 sub-section">
                  Account Recovery Codes
                </h4>
                <div class="flex-box vertically-centered move-up bgap-16" v-if="!recoveryCodes">
                  <SymbiumButton
                    text="View Codes"
                    :onClick="loadRecoveryCodes"
                    :loading='loadingRecoveryCode'
                    :isDialog="true"
                    :isSmall="true"
                    v-if="user.has_recovery_codes"
                    kclass="hgap-16-right"
                  />
                  <SymbiumButton
                    text="Generate New Codes"
                    :onClick="generateNewCodes"
                    :loading='generatingRecoveryCode'
                    :isPrimary="true"
                    :isSmall="true"
                  />
                </div>
                <div class="flex-box wrap flexible" v-if="recoveryCodes">
                  <div class="body-16 gray bgap-24">
                    If you lose access to the device that provided two-factor authentication, you can use these recovery codes to login. Keep these recovery codes somewhere safe, but accessible.
                  </div>
                  <div class="flex-box wrap max-size" v-for="chunk in chunkedCodes" :key="chunk[0]">
                    <div class="flex-box body-15-medium gray codes">
                      <div class="margin-right-3x">
                        {{chunk[0]}}
                      </div>
                      <div class="">
                        {{chunk[1]}}
                      </div>
                    </div>
                  </div>
                  <div class="btn-group wrap bgap-24">
                    <SymbiumButton
                      text="Close"
                      :onClick="clearRecoveryCodes"
                      :isDialog="true"
                      :isSmall="true"
                      kclass="hgap-16-right"
                    />
                    <SymbiumButton
                      text="Copy to Clipboard"
                      :onClick="copyRecoveryCodesToClipboard"
                      :isDialog="true"
                      :isSmall="true"
                      kclass="hgap-16-right"
                    />
                    <SymbiumButton
                      text="Generate New Codes"
                      :onClick="generateNewCodes"
                      :loading='generatingRecoveryCode'
                      :isPrimary="true"
                      :isSmall="true"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gap-1x max-size"></div>
        </div>
      </template>
    </LoadingSection>
  </Layout>
</template>

<script>
import _ from 'lodash'

import EventBus from 'src/components/EventBus.js'
import LoadingSection from '../shares/LoadingSection.vue'
import Layout from 'src/components/dashboard/shares/Layout.vue'
import SymbiumFormGroup from 'src/components/common/form/SymbiumFormGroup.vue'
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import AlertSuccessModal from "src/components/common/modals/AlertSuccessModal.vue"

export default {
  components: {
    Layout, SymbiumFormGroup,
    LoadingSection,
    SymbiumButton, AlertSuccessModal
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      organization: '',
      phone: '',
      loading: true,
      submitting: false,
      dirty: false,
      alertMessage: '',
      user: {},
      loadingQrCode: false,
      qrCode: null,
      authentication_code: null,
      recoveryCodes: null,
      error: null,
      loadingRecoveryCode: false,
      generatingRecoveryCode: false,
    }
  },
  methods: {
    assignUserData(data) {
      this.firstName = data.first_name
      this.lastName = data.last_name
      this.email = data.email
      this.phone = data.phone
      this.user = data
      if(data.organizations[0]) this.organization = data.organizations[0].name
      this.loading = false
      this.dirty = false
    },
    submitData() {
      this.submitting = true
      this.$user.submitUserUpdate({
        firstName: this.firstName,
        lastName: this.lastName,
        phone: this.phone,
      })
    },
    afterSubmittedSucessfully(data) {
      this.firstName = data.first_name
      this.lastName = data.last_name
      this.lastName = data.phone
      this.submitting = false
      this.alertMessage = "Profile has been saved"
      this.$modal.show('alert-success-modal')
    },
    onInputUpdate(value, attribute) {
      this.dirty = true;
      this[attribute] = value;
    },
    loadQrCode() {
      this.loadingQrCode = true
      this.$mfaSession.getQrCode(this.afterLoadingQrCode, this.errorHanlder)
    },
    errorHanlder() {
      this.loadingQrCode = false
      alert('Something went wrong! Please try again.')
    },
    afterLoadingQrCode(response) {
      this.loadingQrCode = false
      this.qrCode = response.data.qr_code
    },
    loadRecoveryCodes() {
      this.loadingRecoveryCode = true
      this.$mfaSession.getRecoveryCodes(
        (response) => {
          this.recoveryCodes = response.data.codes
          this.loadingRecoveryCode = false
        },
        this.errorHanlder
      )
    },
    generateNewCodes() {
      this.generatingRecoveryCode = true
      this.$mfaSession.generateRecoveryCodes(
        (response) => {
          this.recoveryCodes = response.data.codes
          this.generatingRecoveryCode = false
        },
        this.errorHanlder
      )
    },
    submit2Fa() {
      this.submitting = true
      this.$mfaSession.enable2fa(
        this.authentication_code,
        () => {
          this.qrCode = null
          this.loading = true
          this.submitting = false
          this.authentication_code = null
          this.$user.fetchMe();
        },
        () => {
          this.submitting = false
          this.error = "Wrong Authentication Code"
        }
      )
    },
    cancel() {
      this.qrCode = null
      this.authentication_code = null
      this.recoveryCodes = null
    },
    copyRecoveryCodesToClipboard() {
      navigator.clipboard.writeText(this.recoveryCodes.join(', ')).then(() => {
      }, function(error) {
        console.log(error)
      })
    },
    clearRecoveryCodes() {
      this.recoveryCodes = null
    }
  },
  computed: {
    notAllowed() {
      return (
        !this.dirty ||
        !this.firstName || !this.lastName || !this.phone ||
        this.firstName.length == 0 || this.lastName.length == 0 || this.phone.length == 0
      );
    },
    chunkedCodes() {
      return _.chunk(this.recoveryCodes, 2)
    }
  },
  created() {
    EventBus.$on('user-fetched', this.assignUserData)
    EventBus.$on('data-submitted-sucessfully', this.afterSubmittedSucessfully)
  },
  beforeDestroy() {
    EventBus.$off('user-fetched', this.assignUserData)
    EventBus.$off('data-submiited-sucessfully', this.afterSubmittedSucessfully)
  },
  mounted() {
    this.loading = true
    this.$user.fetchMe();
  },
  watch: {
    authentication_code() {
      this.error = null
    }
  }
}
</script>

<style lang="scss">
.profile-input-size,
.profile-button-size {
  width: 394px !important;
}

.profile-input-size-small {
  width: 300px !important;
}

.profile-input-size,
.profile-button-size,
.profile-input-size-small {
  @media screen and (max-width: 576px) {
    width: calc(100vw - 48px) !important;
  }
}
</style>

<style scoped lang="scss">
.security-section {
  padding-bottom: 0 !important;
}

.account-recovery{
  border-top: 0 !important;
}

.sub-section {
  min-width: 314px;
}

.move-up{
  position: relative;
  transform: translateY(-20%);
}

.codes {
  line-height: 24px;
}

.btn-group {
  display: flex;

  button {
    margin-top: 24px;
  }
}
</style>
